angular.module('impactx.warnings').controller('WarningsCtrl', [
    '$scope',
    '$mdDialog',
    'warnings',
    'saveLabel',
    'abortLabel',
    'warningLabel',
    'themeFactory',
    'saveDisabled',
    WarningsCtrl]);

function WarningsCtrl($scope, $mdDialog, warnings, saveLabel, abortLabel, warningLabel, themeFactory, saveDisabled)
{
    $scope.warnings = warnings;
    $scope.saveLabel = saveLabel;
    $scope.abortLabel = abortLabel;
    $scope.warningLabel = warningLabel;
    $scope.saveDisabled = saveDisabled;
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.answer = function ()
    {
        $mdDialog.hide();
    };
}